// Toggle the menu open and close when on mobile
export default function navbar() {
    const navbar = document.querySelector("nav.nav")
    const menuButton = navbar.querySelector('.nav-menu-button');
    if (!navbar) return
    menuButton?.addEventListener('click', function () {
        navbar.classList.toggle('open');
    });

    const scrollCallback = () => {
        if (window.scrollY <= 1) navbar.classList.remove("scrolled")
        else navbar.classList.add("scrolled")
    }
    scrollCallback()
    window.addEventListener("scroll", scrollCallback)

    const navInner = navbar.querySelector('.nav-inner')
    if (!navInner) return
    const resizeFunc = () => {
      navbar.style.setProperty('--nav-max-height', `${navInner.getBoundingClientRect().height}px`)
    }
    const resizeObserver = new ResizeObserver(resizeFunc)
    setTimeout(resizeFunc, 1000)
    resizeFunc()
    resizeObserver.observe(navInner)
}
